import { topics } from "@/mocks/home";

const toneClasses = [
  "bg-secondary-100 text-secondary-900 hover:bg-secondary-200",
  "bg-background-100 text-foreground-800 hover:bg-background-200",
  "bg-accent-100 text-accent-900 hover:bg-accent-200",
  "bg-primary-100 text-primary-800 hover:bg-primary-200",
];

export default function TopicWall() {
  return (
    <section id="topics" className="w-full px-4 md:px-8 mt-14 md:mt-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
        <div className="lg:col-span-3">
          <span className="font-label text-xs tracking-[0.3em] text-primary-600">话题墙</span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
            大家都在议论什么
          </h2>
          <p className="mt-4 font-label text-sm leading-relaxed text-foreground-600">
            每一个标签背后都挂着一批爆料、合集与讨论串。点击任意话题，都是在同一条线索脉络里继续往下走。
          </p>
          <div className="mt-6 rounded-lg bg-secondary-950 p-5 text-background-50">
            <p className="font-label text-xs text-background-50/60">今日最热话题</p>
            <p className="mt-2 font-heading text-xl font-bold">#综艺停摆</p>
            <p className="mt-2 font-label text-sm text-background-50/70">
              24 小时内新增 128 条相关内容
            </p>
          </div>
        </div>

        <div className="lg:col-span-9">
          <div className="flex flex-wrap gap-2.5 md:gap-3">
            {topics.map((topic, index) => (
              <a
                key={topic.name}
                href="#topics"
                className={`group inline-flex items-center gap-2.5 rounded-full px-4 md:px-5 py-2.5 transition-colors cursor-pointer ${
                  toneClasses[index % toneClasses.length]
                }`}
              >
                <span className="font-label text-sm md:text-base font-medium whitespace-nowrap">
                  #{topic.name}
                </span>
                <span className="font-heading text-xs md:text-sm opacity-70">
                  {topic.count}
                </span>
              </a>
            ))}
          </div>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-3">
            <div className="rounded-lg border border-background-200/80 p-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-100 text-foreground-700">
                <i className="ri-line-chart-line"></i>
              </span>
              <p className="mt-3 font-heading text-lg font-semibold text-foreground-950">
                讨论热度
              </p>
              <p className="mt-1 font-label text-xs text-foreground-500">
                近 24 小时 4,180 条讨论
              </p>
            </div>
            <div className="rounded-lg border border-background-200/80 p-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className="ri-user-voice-line"></i>
              </span>
              <p className="mt-3 font-heading text-lg font-semibold text-foreground-950">
                活跃读者
              </p>
              <p className="mt-1 font-label text-xs text-foreground-500">
                本周 1,236 人参与补充
              </p>
            </div>
            <div className="rounded-lg border border-background-200/80 p-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                <i className="ri-check-double-line"></i>
              </span>
              <p className="mt-3 font-heading text-lg font-semibold text-foreground-950">
                已核实线报
              </p>
              <p className="mt-1 font-label text-xs text-foreground-500">
                累计 342 条通过双信源核实
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}